import { Injectable } from '@angular/core';
import { HierarchyTemplate } from '../../viewmodels/admin/hierarchy-templates/hierarchy-template';

@Injectable({
  providedIn: 'root',
})
export class HierarchyTemplatesService {

  public createHierarchyTemplate(): HierarchyTemplate {

    const hierarchyTemplate = new HierarchyTemplate();

    hierarchyTemplate.name = '';
    hierarchyTemplate.description = '';
    hierarchyTemplate.assetFamilyId = null;

    return hierarchyTemplate;
  }
}
